export const SET_API_TOKENS = 'SET_API_TOKENS';
export const DELETE_API_TOKEN = 'DELETE_API_TOKEN';
export const CREATED_API_TOKEN = 'CREATED_API_TOKEN';
export const CLEAN_CREATED_API_TOKEN = 'CLEAN_CREATED_API_TOKEN';